import Radio from './Radio';


Radio.install = function(Vue) {
  Vue.component(Radio.name, Radio);
};

export default Radio;
